/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiMacroprojectsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiMacroprojectsId200Schema = z.object({
  id: z.coerce.number().int().optional(),
  name: z.coerce.string().min(1).max(500),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  isVisible: z.boolean(),
  costCenter: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable(),
});

export const getApiMacroprojectsIdQueryResponseSchema = z.lazy(
  () => getApiMacroprojectsId200Schema,
);
